import { render, staticRenderFns } from "./SiderMenuItems_deprecated.vue?vue&type=template&id=ae9bf8f6&scoped=true&"
import script from "./SiderMenuItems_deprecated.vue?vue&type=script&lang=js&"
export * from "./SiderMenuItems_deprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9bf8f6",
  null
  
)

export default component.exports